<template>
  <div class="header">
    <div class="header-name" :class="{sorted:sortBy==='name'}" @click="emit('sort','name')">
      Nazwa produktu<BaseIcon size="18" :name="icon('name')" />
    </div>
    <div
      class="header-quantity"
      :class="{sorted:sortBy==='quantity'}"
      @click="emit('sort','quantity')"
    >
      Ilość (g)<BaseIcon size="18" :name="icon('quantity')" />
    </div>
    <div class="header-measurement">Miara opisowa</div>
    <div class="header-actions" />
  </div>
</template>
<script lang="ts" setup>
  import BaseIcon from '@/components/BaseIcon.vue'

  defineProps<{ icon: (by: string) => IconName; sortBy: string }>()
  const emit = defineEmits<{ sort: [by: string] }>()
</script>
